<template>
  <div class="alert">

    <h2>{{ title }}</h2>

    <div class="content">
      <slot></slot>

      <div v-if="defaultLink" class="buttons">
        <a v-if="defaultLink === 'refresh'" @click.prevent="refreshPage()">Actualiser la page</a>
        <a v-if="defaultLink === 'home'" @click.prevent="redirectToHome()">Retour à l'accueil</a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    title: String,
    defaultLink: String
  },
  methods: {
    refreshPage () {
      this.$router.go()
    },
    redirectToHome () {
      if (this.$route.params.tenantCode) {
        this.$router.push('/' + this.$route.params.tenantCode)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.alert {
  display: flex;
  flex-direction: column;
  background: white;
  margin: 0 2rem 5rem 2rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

h2 {
  padding: 1.5rem !important;
  font-size: 2rem !important;
  text-align: center !important;
  color: rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.05);
}

.content {
  padding: 3rem 4.5rem;
}

p {
  color: rgba(0, 0, 0, 0.7);
  font-size: 1.3rem;
  line-height: 2.5rem;
}

@media (max-width: 1000px) {
  h2 {
    font-size: 1.5rem !important;
  }

  p {
    padding: 1rem;
    font-size: 1rem;
  }
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .alert {
    /* display: block; */
    width: auto;
    max-width: 700px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NetworkAlert.vue